import React from 'react'

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.33 81">
    <g id="g9" transform="translate(-191 -40)">
      <path data-name="9" d="M0-3434.952c0-25.947,12.079-41.455,31.911-41.455,15.658,0,24.753,6.86,26.99,20.131l-16.85,2.686c-1.342-6.263-4.921-9.4-10.586-9.4-8.8,0-14.017,8.351-14.464,22.368,3.728-5.815,10.439-9.1,19.237-9.1,14.912,0,24.008,9.842,24.008,25.8,0,16.4-11.78,27.885-28.482,27.885C11.78-3396.181,0-3410.348,0-3434.952Zm17.447,8.8c1.044,10.289,6.114,16.552,13.868,16.552,7.307,0,11.78-5.07,11.78-13.569,0-8.2-4.772-13.571-12.079-13.571-6.263,0-11.481,4.03-13.569,10.591Z" transform="translate(256.245 -3355.431) rotate(180)" />
      <rect data-name="Rectangle 3" width="65.33" height="81" transform="translate(191 40)" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Header/Logo/9.js